import React, { useState } from 'react';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import moment from 'moment-timezone';
import _ from 'underscore';

import { VerticalSeparator, HorizontallyCenteringContainer, extractRecentVoucherRedemptionsFromMemberData, daysElapsedSince } from './utils';

import { MembershipCardRow } from './MembershipCard';
import Voucher, { getExpiryForAdditionalVoucher } from './Voucher';

export default function Kid({ kid, parentToken, updateMemberData }) {
    const imgSrc = '/kid.jpg'

    const [showModal, setShowModal] = useState(false);

    const name = kid?.MemberInfo?.Name;
    const cardId = kid?.CardInfo?.CardNo;
    const tierCode = kid?.CardInfo?.TierCode;
    const pointsBAL = kid?.CardInfo?.PointsBAL;

    const hasExpiryInfo = kid.CardInfo?.RewardCycleLists?.length > 0;
    let currentCycleEnd = null;
    if (hasExpiryInfo) {
        kid.CardInfo?.RewardCycleLists.forEach(expiryInfo => {
            if (expiryInfo.PointsType === 'Current') {
                currentCycleEnd = new Date(expiryInfo.PointsExpiringDate);
            }
        });
    }

    const voucherLists = kid?.VoucherLists || [];

    const additionalVouchers = (kid?.__additional_vouchers__ || []).filter(voucher => {
        const expiryDate = getExpiryForAdditionalVoucher(voucher, kid);
        return expiryDate.getTime() + 1000 * 60 * 60 * 24 - 1 > (new Date()).getTime();
    });

    const redeemedVouchers = extractRecentVoucherRedemptionsFromMemberData(kid)
        .filter(redemption => daysElapsedSince(redemption.ts) < 7);
    console.log(`Last Redeemed Vouchers for ${name} (${cardId}):`, redeemedVouchers);

    function MyHR({ additionalStyles = {} }) {
        return (
            <hr style={_.extend({ color: 'var(--swensens-brand-color)', opacity: 1, borderTop: '3px solid' }, additionalStyles)}/>
        )
    }

    return (
        <>
            <VerticalSeparator height='3px'/>
            <div className='kid' onClick={() => setShowModal(true)}>
                <img alt={name} src={imgSrc}/>
                <div className='kid-text'>
                    <div className='kid-text-heading'>{name}</div>
                    <div className='kid-text-footer'>
                        {_.range(15).map(idx => (
                            <img
                                key={`key-${idx}`} alt={idx < pointsBAL ? 'point' : '-'}
                                style={{ width: '6%' }}
                                src={idx < pointsBAL ? 'kid-progress-filled.png' : 'kid-progress-not-filled.png'}
                            />
                        ))}
                    </div>
                </div>
            </div>
            <VerticalSeparator height='3px'/>
            <Modal
                show={showModal} fullscreen={true}
                onHide={() => {
                    setShowModal(false);
                }}
            >
                <div style={{
                    height: 'calc(20px)',
                    backgroundColor: 'var(--app-top-strip-color)'
                }}/>
                <Modal.Body style={{ paddingTop: '10px' }}>
                    <HorizontallyCenteringContainer>
                        <div style={{ width: '360px', paddingTop: '0px', paddingLeft: '10px', paddingRight: '10px', fontSize: '1em' }}>
                            <div style={{ width: '340px' }}>
                                <div>
                                    <MembershipCardRow
                                        name={name}
                                        cardId={cardId}
                                        tierCode={tierCode}
                                    />
                                    
                                    <VerticalSeparator height='0.5em'/>

                                    <HorizontallyCenteringContainer>
                                        <p className="app-text-left-align" style={{ lineHeight: '1.2em', position: 'relative', top: '8px' }}>
                                            {
                                                pointsBAL < 15 ? (
                                                    <>
                                                        Collect <span className="swensens-color bold">{Math.floor(Math.round(15 - pointsBAL))}</span> more stamps to redeem your Earthquake Sundae.
                                                    </>
                                                ) : (
                                                    <>
                                                        Visit Swensen’s to redeem your complimentary Earthquake Sundae!
                                                    </>
                                                )
                                            }
                                        </p>
                                        <img
                                            style={{ height: '72px' }} alt='earthquake'
                                            src='app-membership-earthquake.png'
                                        />
                                    </HorizontallyCenteringContainer>
                                    <MyHR additionalStyles={{ margin: '0px' }} />
                                    <HorizontallyCenteringContainer additionalStyles={{ flexWrap: 'wrap' }}>
                                        {_.range(15).map(idx => (
                                            <img
                                                key={`key-${idx}`} alt={idx < pointsBAL ? 'point' : '-'}
                                                style={{ width: '20%' }}
                                                src={idx < pointsBAL ? 'app-membership-bear-awake.png' : 'app-membership-bear-asleep.png'}
                                            />
                                        ))}
                                    </HorizontallyCenteringContainer>
                                    <VerticalSeparator height='5px'/>
                                    <HorizontallyCenteringContainer>
                                        <p className="app-text" style={{ fontSize: '0.8em' }}>
                                            Kid's Meal Stamps expire on {moment(currentCycleEnd).format('DD MMM YYYY')}
                                        </p>
                                    </HorizontallyCenteringContainer>
                                </div>
                            </div>
                        </div>
                    </HorizontallyCenteringContainer>
                    <MyHR/>
                    {
                        (voucherLists.length + additionalVouchers.length) > 0 && (
                            <>
                                <p className="app-text">
                                    <strong>My eVouchers</strong>
                                </p>
                                {
                                    voucherLists.map((voucher, idx) => (
                                        <Voucher
                                            key={`voucher-${idx}`}
                                            voucher={voucher}
                                            token={parentToken}
                                            childCardNumber={cardId}
                                            updateMemberData={updateMemberData}
                                            lastRedemptionRecord={redeemedVouchers.find(item => item.voucherNumber === voucher.VoucherNo)}
                                            memberData={kid}
                                        />
                                    ))
                                }
                                {
                                    additionalVouchers.map((voucher, idx) => (
                                        <Voucher key={`additional-voucher-${idx}`}
                                            voucher={voucher}
                                            voucherType='additional'
                                            token={parentToken}
                                            childCardNumber={cardId}
                                            updateMemberData={updateMemberData}
                                            lastRedemptionRecord={redeemedVouchers.find(item => item.voucherNumber === voucher.vid)}
                                            memberData={kid}
                                        />
                                    ))
                                }
                                <MyHR/>
                            </>
                        )
                    }
                    {
                        redeemedVouchers.length > 0 && (
                            <>
                                <p className="app-text">
                                    <strong>Recently Redeemed eVouchers</strong>
                                </p>
                                {
                                    redeemedVouchers.map(({ ts, data: { voucherData: voucher, voucherType } }, idx) => (
                                        <Voucher key={`redeemed-voucher-${idx}`}
                                            voucher={voucher}
                                            voucherType={voucherType}
                                            childCardNumber={cardId}
                                            redemptionDate={ts}
                                            memberData={kid}
                                            redemptionRecord={redeemedVouchers[idx]}
                                        />
                                    ))
                                }
                                <MyHR/>
                            </>
                        )
                    }
                    <VerticalSeparator height='1.5em'/>
                    <HorizontallyCenteringContainer>
                        <Button
                            style={{ width: '240px' }}
                            className="swensens-button"
                            onClick={() => {
                                setShowModal(false);
                            }}
                        >BACK</Button>
                    </HorizontallyCenteringContainer>
                    <VerticalSeparator height='1.5em'/>
                </Modal.Body>
            </Modal>
        </>
    )
}
